const regimeTributarioEspecial = {
  SEM_REGIME_TRIBUTARIO: 'Sem Regime Tributário Especial',
  MICRO_MUNICIPAL: 'Microempresa Municipal',
  ESTIMATIVA: 'Estimativa',
  SOCIEDADE_PROFISSIONAIS: 'Sociedade de Profissionais',
  COOPERATIVA: 'Cooperativa',
  MEI: 'Microempresário Individual - MEI',
  ME_EEP: 'Microempresa ou Pequeno Porte - ME EPP',
};

export default regimeTributarioEspecial;
